var React = require('react');

function Samsung (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.738 15.529c0-3.052-3.286-3.529-5.662-3.529-2.99 0-5.433.825-5.879 3.111C.08 15.736.06 16.295.237 17c.73 2.861 6.7 3.69 7.568 5.502.161.339.11.773.031 1.036-.138.467-.517.944-1.637.944-1.05 0-1.69-.507-1.69-1.27v-1.358H0v1.079C0 26.056 2.947 27 6.108 27c3.038 0 5.54-.862 5.938-3.2.205-1.21.055-2.003-.016-2.296-.71-2.933-7.086-3.808-7.564-5.449a1.504 1.504 0 0 1-.015-.737c.118-.45.485-.94 1.535-.94.986 0 1.558.506 1.558 1.27v.867h4.194v-.986zM29.7 27l-3.36-15-8.11.004L14.85 27h4.926l2.495-13.61h.102L24.8 27h4.9zM54 27l-.402-15-7.424.004-2.245 11.464h-.108l-2.24-11.464h-7.429L33.75 27h4.559l.111-13.482h.103L41.563 27h4.623l3.045-13.479h.099L49.445 27H54z","fill":"#fff"}));
}

Samsung.defaultProps = {"width":"54","height":"40","viewBox":"0 0 54 40","fill":"none"};

module.exports = Samsung;

Samsung.default = Samsung;
